import { Box, Divider, IconButton, LinearProgress, Table, TableBody, TableCell, TableHead, TableRow, Toolbar, Typography } from '@mui/material';
import { LayoutBase } from '../../layouts';
import { useEffect, useState } from 'react';
import { SupportServices } from '../../services/api/suport/SuportServices';
import { ToolsDetails } from '../../components/custom';

export default function Support() {
	const [data, setData] = useState<any | null>(null);

	useEffect(() => {
		fetchData();
	}, []);

	async function fetchData() {
		const response = await SupportServices.get();
		if(response){
			setData(response);
		}
	}

	return(
		<LayoutBase
			title="Chamados de Suporte"
			tollBar={
				<ToolsDetails
					showNewButton={false}
					showDeletButton={false}
					showSaveButton={false}
				/>
			}
		>
			<Box>
				<Typography variant='h5'>Listagem de Chamados</Typography>
				<Divider />
				{data === null ? 
					<LinearProgress sx={{margin: 2}}/>
				: 
					<Box sx={{margin: 2, borderColor: 'black', border:1, borderRadius: '25px'}}>
						<Table
							sx={{
								'& td, & th': {
									borderBottom: '1px solid rgba(224, 224, 224, 1)', // padrão do MUI
								},
								'& tbody tr:last-of-type td': {
									borderBottom: 'none',
								},
								borderCollapse: 'separate',
								borderSpacing: 0,
							}}
						>
							<TableHead>
								<TableRow>
									<TableCell sx={{ borderBottom: 'none' }}>E-mail</TableCell>
									<TableCell sx={{ borderBottom: 'none' }}>Mensagam</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{data.map((index: any) => (
								<TableRow key={index.uuid} >
									<TableCell sx={{ borderBottom: 'none' }}>{index.email}</TableCell>
									<TableCell sx={{ borderBottom: 'none' }}>{index.mensagem}</TableCell>
								</TableRow>
								))}
							</TableBody>
						</Table>
					</Box>
				}
			</Box>
		</LayoutBase>
	);
}